
import { map } from 'es-toolkit/compat';
import PhoneCountryCodes from './PhoneCountryCodes';

export default map(PhoneCountryCodes, (entry) => ({
  key: `${entry.phone} ${entry.iso}`,
  value: `${entry.phone} ${entry.iso}`,
  label: `${entry.phone} ${entry.name}`,
  display: `${entry.phone}`,
}));
